import React, { Suspense, createContext, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import UILoader from '@/components/ui/loader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PageTrainingCourse = /*#__PURE__*/lazy(function () {
  return import('@/components/page/training/course');
});
var PageTrainingPackage = /*#__PURE__*/lazy(function () {
  return import('@/components/page/training/package');
});
var PageTrainingLearningPath = /*#__PURE__*/lazy(function () {
  return import('@/training/components/LearningPathPage');
});
export var PageTrainingContext = /*#__PURE__*/createContext({
  parent: null,
  path: '/training'
});

var PageTrainingProvider = function PageTrainingProvider(_ref) {
  var children = _ref.children,
      _ref$parent = _ref.parent,
      parent = _ref$parent === void 0 ? null : _ref$parent,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '/training' : _ref$path;
  return /*#__PURE__*/_jsx(PageTrainingContext.Provider, {
    value: {
      path: path,
      parent: parent
    },
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: /*#__PURE__*/_jsx(UILoader, {}),
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: "".concat(path, "/learning-path/:learningPathSlug/(section)?/:sectionSlug?"),
          children: /*#__PURE__*/_jsx(PageTrainingLearningPath, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "".concat(path, "/course/:slug"),
          children: /*#__PURE__*/_jsx(PageTrainingCourse, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "".concat(path, "/package/:slug"),
          children: /*#__PURE__*/_jsx(PageTrainingPackage, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "*",
          children: children
        })]
      })
    })
  });
};

export default PageTrainingProvider;